import englishLanguage from './en/index';
import hungarianLanguage from './hu/index';

let languages = {
	hu: hungarianLanguage,
	en: englishLanguage
};

export default languages;
